import { render, staticRenderFns } from "./AssetInformation.vue?vue&type=template&id=2b0d96c3&scoped=true&"
import script from "./AssetInformation.vue?vue&type=script&lang=js&"
export * from "./AssetInformation.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformation.vue?vue&type=style&index=0&id=2b0d96c3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d96c3",
  null
  
)

export default component.exports